import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolTypography } from '@synergy/components';
import { useState } from 'react';

import * as CustomerDetailOverviewActions from '../store/customer-detail-overview-actions';
import { BankAccountFormValues } from '../../../../models/bank-account-form-values';
import { BankAccountsModal } from '../../../../components/bank-accounts/bank-accounts-modal';
import { BankAccountsTable } from '../../../../components/bank-accounts/bank-accounts-table';
import {
    customerDetailOverviewBankAccountsSelector,
    customerSelector,
} from '../store/customer-detail-overview-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../../../store/use-thunk-dispatch';

export const CustomerDetailOverviewBankAccounts = () => {
    const [bankAccount, setBankAccount] = useState<BankAccountFormValues | null>(null);
    const [deleteId, setDeleteId] = useState<number | null>(null);
    const dispatch = useThunkDispatch();
    const customer = useAppSelector(customerSelector);
    const { formValues, errors } = useAppSelector(customerDetailOverviewBankAccountsSelector);

    const handleBankAccountSubmit = async (values: BankAccountFormValues) => {
        const response = values.id
            ? await dispatch(CustomerDetailOverviewActions.updateExistingBankAccount(values))
            : await dispatch(CustomerDetailOverviewActions.addNewBankAccount(values));

        if (response?.success) {
            setBankAccount(null);
        }
    };

    const handleBankAccountDelete = () => {
        if (deleteId) {
            dispatch(CustomerDetailOverviewActions.deleteBankAccount(deleteId));
            setDeleteId(null);
        }
    };

    const actionChildren = [
        <PoolButton key="1" styleType="firstLevel" variant="text" onClick={() => setDeleteId(null)}>
            <FormattedMessage id="app.common.cancel" />
        </PoolButton>,
        <PoolButton key="2" styleType="firstLevel" color="secondary" onClick={handleBankAccountDelete}>
            <FormattedMessage id="app.common.delete" />
        </PoolButton>,
    ];

    return (
        <>
            <BankAccountsTable
                organizationId={customer?.id}
                bankAccounts={formValues ?? []}
                onBankAccountDelete={id => setDeleteId(id)}
                onBankAccountEdit={setBankAccount}
                onNewBankAccount={() =>
                    setBankAccount({
                        id: bankAccount?.id,
                        iban: bankAccount?.iban ?? '',
                        bic: bankAccount?.bic ?? '',
                        mandate: bankAccount?.mandate ?? '',
                        mandateDate: bankAccount?.mandateDate,
                        customerReference: bankAccount?.customerReference ?? '',
                        media: bankAccount?.media ?? [],
                    })
                }
            />

            <BankAccountsModal
                bankAccount={bankAccount}
                errors={errors}
                onClose={() => setBankAccount(null)}
                onBankAccountSubmit={handleBankAccountSubmit}
            />

            <PoolModal
                title={<FormattedMessage id="app.contactsAndOrganizations.detail.deleteBankAccount" />}
                isVisible={!!deleteId}
                handleClose={() => setDeleteId(null)}
                actionChildren={actionChildren}
                hasModalTypography={true}
            >
                <PoolTypography id="app.contactsAndOrganizations.detail.deleteBankAccountText" />
            </PoolModal>
        </>
    );
};
